import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Link, Text } from 'rebass';
import { getLogoSource } from '../../../scheduleDoctor/helpers/insuranceLogos';
import moment from 'moment';
import { GET_BRIDGE_CONSENTS_TO_AGREE } from '../../../../graphql';
import SpinLoader from '../../../../components/SpinLoader';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import ConfirmModal from '../../../../components/ConfirmModal';

const ModalInner = styled(Flex)`
  flex-direction: column;
  max-width: 600px;
  width: 100%;
`;
export const ConsentBox = ({ consent, onClick, isChecked }) => {
  const [label, setLabel] = useState();

  useEffect(
    () => {
      switch (consent.type) {
        case 'ASSIGNMENT_OF_BENEFITS':
          setLabel({
            text: 'Assignment of benefits',
            url: 'https://static.cloudhealthmedicalgroup.com/docs/Assignment+of+Benefits+-+2024-05-13.pdf',
          });
          break;
        case 'CONSENT_TO_TREAT':
          setLabel({
            text: 'Consent to treat',
            url: 'https://static.cloudhealthmedicalgroup.com/docs/Consent+for+Healthcare+Services+-+2024-05-13.pdf',
          });
          break;
        case 'PRIVACY_NOTICE':
          setLabel({
            text: 'Privacy notice',
            url: 'https://bridge-static-files.s3.amazonaws.com/legal/Bridge_Privacy_Policy_2024-04-14.pdf',
          });
          break;

        default:
          break;
      }
    },
    [consent]
  );

  if (!label) return <div />;
  return (
    <Flex style={{ gap: '16px', alignItems: 'center' }}>
      <Flex style={{ border: '1px solid #344f79', width: 16, height: 16, background: isChecked ? '#344f79' : 'white' }} onClick={onClick}>
        <svg fillRule="evenodd" viewBox="0 0 12 9" style={{ display: isChecked ? 'initial' : 'none' }}>
          <path d="M4.1 6.1L1.4 3.4 0 4.9 4.1 9l7.6-7.6L10.3 0z" fill="white" />
        </svg>
      </Flex>
      <Text>
        <span onClick={onClick}>I read and agreed to</span>{' '}
        <Link href={label.url} target="_blank" style={{ color: '#344f79' }}>
          {label.text}
        </Link>
        *
      </Text>
    </Flex>
  );
};
export const OnFileInsuranceBridge = ({ insurance, useOnFileInsurance, wizard, session, InsuranceMemberChanged, insuranceMemberLost, revalidatePolicy, setConsents }) => {
  const [consented, setConsented] = useState([]);
  const [mustAcceptTerms, setMustAcceptTerms] = useState(false);
  return (
    insurance &&
    insurance.payer && (
      <Query query={GET_BRIDGE_CONSENTS_TO_AGREE}>
        {({ loading, data: dataConsents }) => {
          console.log(dataConsents);
          return (
            <>
              {!!loading ? (
                <SpinLoader />
              ) : (
                <Card p={4} mb={4}>
                  <Flex mb={4} flexDirection="column">
                    <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                      <Flex flexDirection={'column'}>
                        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                          <div>
                            <img src={getLogoSource(insurance.payer.name)} alt="" width="220px" />
                          </div>
                        </Flex>
                        {insurance.status === 'PENDING' ? (
                          <Text textAlign="center" mt={4}>
                            Your insurance information is under review by our team
                          </Text>
                        ) : (
                          <>
                            <Text fontWeight="600" textAlign="center" mt={4} fontSize="24px">
                              We Have an Insurance on File
                            </Text>
                            <Text textAlign="center" mt={4} fontSize="18px">
                              {`Member ID: ${insurance.memberId}`}
                            </Text>
                          </>
                        )}

                        <Button
                          variant="pink"
                          mt={4}
                          onClick={() => {
                            if (dataConsents && dataConsents.getBridgeConsentsToAgree && dataConsents.getBridgeConsentsToAgree.filter((x) => consented.indexOf(x.id) < 0).length > 0) {
                              setMustAcceptTerms(true);
                              return;
                            }
                            setConsents(consented);
                            // console.log({ insurance });
                            if (insurance.latest) {
                              const lastCheck = moment(insurance.latest.validatedAt).diff(moment(), 'day');
                              if (lastCheck > 14) {
                                revalidatePolicy();
                                return;
                              }
                            }
                            useOnFileInsurance(insurance, wizard);
                          }}
                        >
                          {insurance.status === 'PENDING' ? 'Continue' : 'Continue with this insurance'}
                        </Button>
                      </Flex>
                    </Flex>
                    {session &&
                      session.isMember &&
                      session.membershipSpecific === 'insurance' && (
                        <>
                          <div
                            style={{
                              height: '1px',
                              backgroundColor: '#ccc',
                              margin: '40px -32px',
                            }}
                          />
                          <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" textAlign="center">
                            <Button
                              mb={3}
                              variant={'primary'}
                              onClick={() => {
                                if (InsuranceMemberChanged) InsuranceMemberChanged();
                              }}
                            >
                              My insurance has changed
                            </Button>
                            <Button
                              variant={'primary'}
                              onClick={() => {
                                if (insuranceMemberLost) insuranceMemberLost();
                              }}
                            >
                              I lost my coverage
                            </Button>
                          </Flex>
                        </>
                      )}

                    {!!mustAcceptTerms && (
                      <ConfirmModal
                        isOpen={mustAcceptTerms}
                        onClose={() => setMustAcceptTerms(false)}
                        onBackgroundClick={() => setMustAcceptTerms(false)}
                        onConfirm={() => setMustAcceptTerms(false)}
                        childrenManaged
                      >
                        <ModalInner style={{ alignItems: 'initial', maxWidth: '500px' }}>
                          <Heading mb={3}>Patient Consents</Heading>
                          <Text mb={3} fontWeight={300}>{`Please review and accept those terms and conditions from Cloud Health Medical Group, our partner:`}</Text>

                          <Flex style={{ gap: '12px', flexDirection: 'column' }}>
                            {!!dataConsents &&
                              dataConsents.getBridgeConsentsToAgree &&
                              dataConsents.getBridgeConsentsToAgree.map((x) => {
                                return (
                                  <ConsentBox
                                    consent={x}
                                    onClick={(e) => {
                                      if (consented.findIndex((xx) => xx === x.id) > -1) {
                                        setConsented(consented.filter((xx) => xx.id !== x.id));
                                      } else {
                                        setConsented([...consented, x]);
                                      }
                                    }}
                                    isChecked={consented.findIndex((xx) => xx.id === x.id) > -1}
                                  />
                                );
                              })}
                          </Flex>

                          <Flex mt={3} style={{ borderRadius: '14px', border: '1px solid #ffd3cbf0', backgroundColor: '#9d580721', overflow: 'hidden', padding: '12px 16px' }}>
                            <svg width="35" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M7.04183 4.87492H5.9585V3.79159H7.04183M7.04183 9.20825H5.9585V5.95825H7.04183M6.50016 1.08325C5.78884 1.08325 5.08447 1.22336 4.42729 1.49557C3.77011 1.76778 3.17298 2.16677 2.67 2.66976C1.65418 3.68558 1.0835 5.06333 1.0835 6.49992C1.0835 7.93651 1.65418 9.31426 2.67 10.3301C3.17298 10.8331 3.77011 11.2321 4.42729 11.5043C5.08447 11.7765 5.78884 11.9166 6.50016 11.9166C7.93675 11.9166 9.3145 11.3459 10.3303 10.3301C11.3461 9.31426 11.9168 7.93651 11.9168 6.49992C11.9168 5.78859 11.7767 5.08423 11.5045 4.42705C11.2323 3.76987 10.8333 3.17274 10.3303 2.66976C9.82734 2.16677 9.23021 1.76778 8.57303 1.49557C7.91585 1.22336 7.21149 1.08325 6.50016 1.08325Z"
                                fill="#9d5807"
                              />
                            </svg>

                            <Text style={{ fontSize: '14px', fontWeight: 500, color: '#9d5807' }} ml={'6px'}>
                              * Required to continue
                            </Text>
                          </Flex>

                          <Button
                            variant="primary"
                            mt={4}
                            style={{ alignSelf: 'center' }}
                            disabled={
                              dataConsents && dataConsents.getBridgeConsentsToAgree && dataConsents.getBridgeConsentsToAgree.filter((x) => consented.findIndex((xx) => xx.id === x.id) < 0).length > 0
                            }
                            onClick={() => {
                              setConsents(consented);
                              // console.log({ insurance });
                              if (insurance.latest) {
                                const lastCheck = moment(insurance.latest.validatedAt).diff(moment(), 'day');
                                if (lastCheck > 14) {
                                  revalidatePolicy();
                                  return;
                                }
                              }
                              useOnFileInsurance(insurance, wizard);
                            }}
                          >
                            Continue
                          </Button>
                        </ModalInner>
                      </ConfirmModal>
                    )}
                  </Flex>
                </Card>
              )}
            </>
          );
        }}
      </Query>
    )
  );
};
